import { render, staticRenderFns } from "./CMTabs.vue?vue&type=template&id=15c923aa&lang=pug"
import script from "./CMTabs.vue?vue&type=script&lang=js"
export * from "./CMTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports